import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./swal.scss";

const MySwal = withReactContent(Swal);
const swalOptions = {
  confirmButtonColor: "#3085d6",
  cancelButtonColor: "#d33",
  confirmButtonText: "אישור",
  customClass: {
    popup: "custom-swal-popup", // Use this class to apply specific styles
  },
};

const Toast = MySwal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
export const showSuccessToast = (message) =>
  Toast.fire({ icon: "success", title: message });
export const showErrorToast = (message) =>
  Toast.fire({ icon: "error", title: message });

export const confirmDelete = () => {
  return MySwal.fire({
    ...swalOptions,
    title: "האם אתה בטוח?",
    text: "לא תוכל לבטל פעולה זו!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "כן, מחק!",
  });
};
export const successMessage = ({ title, message, confirmButtonText }) => {
  return MySwal.fire({
    ...swalOptions,
    title: title || "הצלחה!",
    text: message,
    icon: "success",
    confirmButtonText: confirmButtonText || "אישור",
  });
};
export const errorMessage = (message) => {
  return MySwal.fire({
    ...swalOptions,
    title: "שגיאה!",
    text: message,
    icon: "error",
    confirmButtonText: "אישור",
  });
};
// Cache scrollbar width to avoid recalculating
let cachedScrollbarWidth = null;

function getScrollbarWidth() {
  // Return cached value if available
  if (cachedScrollbarWidth !== null) {
    return cachedScrollbarWidth;
  }
  
  // Create a temporary block element
  const block = document.createElement("div");
  block.style.cssText = "visibility:hidden;overflow:scroll;position:absolute;";
  document.body.appendChild(block);

  // Create a child for that block that will act as the content
  const child = document.createElement("div");
  block.appendChild(child);

  // Calculate the difference between the block and child widths
  cachedScrollbarWidth = block.offsetWidth - child.offsetWidth;

  // Remove the block from the document
  document.body.removeChild(block);

  return cachedScrollbarWidth;
}

export const bigErrorMessage = (title) => {
  // Save original styles before modifying
  const originalOverflow = document.body.style.overflow;
  const originalPaddingRight = document.body.style.paddingRight;
  
  return MySwal.fire({
    ...swalOptions,
    title: title,
    icon: "error",
    didOpen: () => {
      const scrollbarWidth = getScrollbarWidth();
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    },
    willClose: () => {
      // Restore original styles
      document.body.style.overflow = originalOverflow || "";
      document.body.style.paddingRight = originalPaddingRight || "";
    },
  });
};
